import React, { useState, useRef, useMemo } from 'react';
import IntroPage from './components/IntroPage';
import FormPage1 from './components/FormPage1';
import FormPage2 from './components/FormPage2';
import ResultPage from './components/ResultPage';
import LeftPane from './components/LeftPane';

export default function WastageCalculator() {
  // State variables
  const [pageOn, setPageOn] = useState('formIntro');
  const [numberOfDripTrays, setNumberOfDripTrays] = useState('');
  const [numberOfDripTraysEmptied, setNumberOfDripTraysEmptied] = useState('');
  const [averageCostPerPint, setAverageCostPerPint] = useState('');
  const [averageSalePricePerPint, setAverageSalePricePerPint] = useState('');
  const [sizeOfDripTrays, setSizeOfDripTrays] = useState('');

  const draughtWastageRef = useRef(null);

  // Methods
  const gotoFormPage = () => {
    setPageOn('form1');
    if (!checkIsOnScreen()) {
      draughtWastageRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const gotoFormPage2 = (event) => {
    event.preventDefault();
    setPageOn('form2');
    if (!checkIsOnScreen()) {
      draughtWastageRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const gotoResultPage = (event) => {
    event.preventDefault();
    setPageOn('result');
    if (!checkIsOnScreen()) {
      draughtWastageRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const gotoSignupNowPage = () => {
    window.location.href = '/courses/dispense-course/';
  };

  const checkIsOnScreen = () => {
    const rect = draughtWastageRef.current.getBoundingClientRect();
    return rect.top >= 0;
  };

  // Computed properties
  const costPriceLostPerYear = useMemo(() => {
    return (
      Number(numberOfDripTrays || 0) *
      Number(numberOfDripTraysEmptied || 0) *
      Number(sizeOfDripTrays || 0) *
      Number(averageCostPerPint || 0) *
      365
    );
  }, [numberOfDripTrays, numberOfDripTraysEmptied, sizeOfDripTrays, averageCostPerPint]);

  const salesValueLostPerYear = useMemo(() => {
    return (
      Number(numberOfDripTrays || 0) *
      Number(numberOfDripTraysEmptied || 0) *
      Number(sizeOfDripTrays || 0) *
      Number(averageSalePricePerPint || 0) *
      365
    );
  }, [numberOfDripTrays, numberOfDripTraysEmptied, sizeOfDripTrays, averageSalePricePerPint]);

  const numberOfChars = useMemo(() => {
    const total = parseInt(costPriceLostPerYear);
    const numChars = '£' + total;
    return 'length-' + Math.max(5, Math.min(8, numChars.length));
  }, [costPriceLostPerYear]);

  // Helper function for currency formatting
  const currency = (value, currencySymbol = '£', decimals = 0, options = {}) => {
    const { thousandsSeparator = ',' } = options;
    const formattedValue = parseFloat(value)
      .toFixed(decimals)
      .replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);
    return `${currencySymbol}${formattedValue}`;
  };

  return (
    <div className="draught-wastage__container" ref={draughtWastageRef}>
      <LeftPane />

      <div className="draught-wastage">

        {pageOn === 'formIntro' && (
          <IntroPage
            onNextPage={gotoFormPage}
          />
        )}


        {pageOn === 'form1' && (
          <FormPage1

            numberOfDripTrays={numberOfDripTrays}
            setNumberOfDripTrays={setNumberOfDripTrays}
            numberOfDripTraysEmptied={numberOfDripTraysEmptied}
            setNumberOfDripTraysEmptied={setNumberOfDripTraysEmptied}
            sizeOfDripTrays={sizeOfDripTrays}
            setSizeOfDripTrays={setSizeOfDripTrays}
            gotoFormPage2={gotoFormPage2}

          />)
        }


        {pageOn === 'form2' && (
          <FormPage2
            averageCostPerPint={averageCostPerPint}
            setAverageCostPerPint={setAverageCostPerPint}
            averageSalePricePerPint={averageSalePricePerPint}
            setAverageSalePricePerPint={setAverageSalePricePerPint}
            gotoResultPage={gotoResultPage}
          />
        )}

        {pageOn === 'result' && (
          <ResultPage
            costPriceLostPerYear={costPriceLostPerYear}
            salesValueLostPerYear={salesValueLostPerYear}
            gotoSignupNowPage={gotoSignupNowPage}
            currency={currency}
            numberOfChars={numberOfChars}
          />
        )}
      </div>


    </div>
  );
}

